module.exports = __webpack_public_path__ + "img/vertical_2_1_9006.5679afaf.png";